import React from 'react';
import { Brain, TrendingUp, ShieldAlert, Coins } from 'lucide-react';
export function Topics() {
  const topics = [{
    icon: <Brain className="text-red-600" size={32} data-id="element-160" />,
    title: 'Digital Transformation in Retail Finance',
    description: 'Explore how AI and digital technologies are transforming financial operations, forecasting, and decision-making in commerce businesses.'
  }, {
    icon: <TrendingUp className="text-red-600" size={32} data-id="element-161" />,
    title: 'Omnichannel Financial Strategy',
    description: 'Develop a cohesive financial approach to support seamless customer experiences across physical and digital retail channels.'
  }, {
    icon: <ShieldAlert className="text-red-600" size={32} data-id="element-162" />,
    title: 'Supply Chain Financial Resilience',
    description: 'New frameworks for identifying and mitigating financial risks in increasingly complex global supply chains.'
  }, {
    icon: <Coins className="text-red-600" size={32} data-id="element-163" />,
    title: 'Capital Allocation for Retail Growth',
    description: 'Optimize your approach to investments in store networks, e-commerce platforms, and digital capabilities for maximum ROI.'
  }];
  return <section id="topics" className="py-20 bg-white" data-id="element-164">
      <div className="container mx-auto px-4 md:px-6" data-id="element-165">
        <div className="text-center mb-16" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-167">
            Discussion Topics
          </h2>
          <div className="mt-4 w-24 h-1 bg-red-600 mx-auto" data-id="element-168"></div>
          <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-169">
            Our carefully curated agenda addresses the most pressing challenges
            and opportunities facing commerce financial leaders today.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-170">
          {topics.map((topic, index) => <div key={index} className="flex gap-5 p-6 border border-gray-100 rounded-lg hover:shadow-md transition-shadow" data-id="element-171">
              <div className="shrink-0" data-id="element-172">{topic.icon}</div>
              <div data-id="element-173">
                <h3 className="text-xl font-semibold mb-2" data-id="element-174">{topic.title}</h3>
                <p className="text-gray-600" data-id="element-175">{topic.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}